import { SiteConfig } from './types'

const cz: SiteConfig = {
  variant: 'cz',
  routePrefix: 'cz',

  features: {
    shorts: false,
    stats: true,
    formulasImageUrl: null,
  },

  subjects: [
    { id: 'cz-dt', label: 'Didaktický test' },
  ],

  payments: {
    periods: [
      { id: '2026_27', productId: 'kuramatura_cz_analyzy_2026_27', title: '2026/27', price: 'Kč250' },
    ],
    currentPeriodId: '2026_27',
    currentProductId: 'kuramatura_cz_analyzy_2026_27',
    checkoutBaseUrl: 'https://kuramatura.cz/checkout/stripe',
    explainProductId: 'kuramatura_cz_explain',
    explainPrice: 'Kč250',
  },

  firebase: {
    appId: '1:443202482105:web:55247260004ab119c51068',
    measurementId: 'G-Z0DN1DX28T',
  },

  siteUrl: 'https://kuramatura.cz',
  siteTitle: 'Kura Matura',
  siteDescription: 'Interaktivní Online Příprava na Maturitu',

  contact: {
    email: 'contact@kuramatura.eu',
    privacyUrl: '/legal/privacy-policy.txt',
    donateUrl: 'https://donate.stripe.com/3cscQGc7f3NX5DW288',
  },

  labels: {
    nav: {
      tests: 'Testy',
      shorts: 'Shorts',
      stats: 'Statistiky ★',
      previous: 'Předchozí testy',
      about: 'O Projektu',
      donate: 'Podpořit',
      footer: 'Se souhlasem NiVam',
    },

    headers: {
      tests: 'PŘEDMĚT',
      shorts: 'SHORTS',
      stats: 'STATISTIKY',
    },

    test: {
      start: 'ZAČÍT TEST',
      end: 'Ukončit test',
      back: 'Zpět na výběr testů',
      questionCount: 'otázek',
      durationMinutes: 'minut',
      loginPrompt: 'Pro ukládání výsledků testů a statistiky se přihlaste.',
      loginButton: 'Přihlásit se',
      showFormulas: 'Zobrazit vzorce',
      hideFormulas: 'Skrýt vzorce',
      correctAnswers: 'Správné odpovědi:',
      allCorrectAnswers: 'Všechny správné odpovědi:',
      noCorrectAnswer: 'Nemá správnou odpověď',
      notCaseSensitive: 'Na velikosti písmen nezáleží',
      correctAnswerPrefix: 'Správná odpověď:',
    },

    testSidebar: {
      duration: 'Trvalo',
      correct: 'Správně',
      timeLeft: 'Zbývá',
      answered: 'Vyplněno',
    },

    shorts: {
      correct: 'Správně',
      incorrect: 'Špatně',
      next: 'Další otázka',
      finish: 'Konec',
      subjectDescription: 'rychlý kvízový formát maturity',
      pickerDescription: 'Rychlý kvízový formát testování pro maturanty',
    },

    stats: {
      heading: 'Statistiky',
      periodLabel: 'Období',
      subjectLabel: 'Předmět',
      cumulativeLabel: 'Kumulativní',
      allSubjects: 'Vše',
      periods: {
        last7: 'Poslední týden',
        last14: 'Poslední dva týdny',
        last30: 'Poslední měsíc',
        all: 'Celé období',
      },
      modes: {
        cumulative: 'Kumulativní',
        nonCumulative: 'Nekumulativní',
      },
      graphs: {
        success: 'Úspěšnost',
        tests: 'Počet vyplněných testů',
        totalQuestions: 'Počet zadaných otázek',
        answered: 'Počet zodpovězených otázek',
        correct: 'Počet správných odpovědí',
      },
    },

    auth: {
      loading: 'Načítá se...',
      statsPrompt: 'Pro přístup ke statistikám se přihlaste.',
      testPrompt: 'Pro ukládání výsledků testů a statistiky se přihlaste.',
      button: 'Přihlásit se',
      emailSent: 'Email odeslán',
      emailSentBody: 'Odkaz pro přihlášení byl odeslán na tvoji emailovou adresu.',
      sendingEmail: 'Odesílám email',
      waiting: 'Čekej prosím...',
      signInTitle: 'Přihlas se pomocí emailu',
      signInBody: 'Na tvoji emailovou adresu ti pošleme odkaz, kterým se můžeš přihlásit.',
      submitButton: 'Odeslat',
      signingInTitle: 'Probíhá přihlašování',
      emailNotFound: 'Email nenalezen',
    },

    donate: {
      prompt: 'Baví tě to?',
      footer: 'méně než 50 centů nejde. kup si rohlík.',
    },

    payment: {
      linkCopied: 'Odkaz máš zkopírovaný',
      sendToParent: 'Poslat rodičům',
      payNow: 'Zaplatit teď',
    },

    explain: {
      loginPrompt: 'Pro vysvětlení se přihlaste.',
      limitReached: 'Dnešní limit vysvětlení byl vyčerpán.',
      purchasePrompt: 'Odemknout neomezená vysvětlení',
      freeUsesLeft: 'Ještě {{count}} bezplatných vysvětlení dnes',
      disclaimer: 'Generováno AI — může obsahovat chyby',
      followUpPlaceholder: 'Zeptej se dál...',
    },

    landing: {
      headline: 'Interaktivní maturitní příprava',
      description: [
        'Rychle. Interaktivně. Efektivně.',
        'Bez zbytečných papírů.',
        'Sleduj svůj pokrok, zlepši se!',
      ],
      cta: ['Netiskneš.', 'Nepláčeš.', 'Testuješ.'],
      button: 'Testuj',
    },

    about: {
      title: 'O nás',
      description: 'Vytvořeno jako alternativa ke status quo - papírové testy a ruční opravování.',
      contactLabel: 'kontakt',
      privacyLabel: 'soukromí',
      privacyText: 'zásady ochrany soukromí',
      donateButton: 'Podpořit',
    },

    previous: {
      title: 'Předchozí testy',
    },
  },
}

export default cz
